export default "__VITE_ASSET__Dt6n0xwy__"